import useRouter from '~/client/hooks/router/useRouter';
import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import useTitleInjection from './useTitleInjection';
import {
  BlogContentNodeFragment,
  useBlogArticleQuery,
} from '../../graphql/BlogArticleQuery.generated';

const useBlogArticle = () => {
  const {
    query: { category, handle },
  } = useRouter();

  const { site } = useSite();
  const { code: language } = useLanguage();

  const { data, loading, refetch } = useBlogArticleQuery({
    variables: {
      filter: {
        handle: handle?.toString(),
        section: `blog-${category}`,
        site,
        language,
      },
    },
  });

  const page = data?.content?.pages?.edges?.[0]?.node;
  const mainBlock = useTitleInjection(page?.mainBlock || '');

  const breadcrumbs: Breadcrumb[] = [
    { to: '/blog', translateId: 'blog.blog' },
    {
      to: `/blog/${category}`,
      translateId: `blog.${category}`,
    },
    {
      translateId: page?.title,
    },
  ];
  return {
    page: { ...page, mainBlock } as BlogContentNodeFragment,
    loading,
    breadcrumbs,
    category: category?.toString(),
    handle: handle?.toString(),
    site,
    refetch,
  };
};

export default useBlogArticle;
